import { Component, OnInit, OnDestroy } from '@angular/core';
import { Category } from '../category.model';
import { CategoriesService } from '../categories.service';
import { LoggingService } from '../../../shared/services/logging/logging.service';

@Component({
    selector: 'ef-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.scss'],
    standalone: false
})
export class CategoryListComponent implements OnInit, OnDestroy {
    private _categoryService: CategoriesService;
    public categories: Category[];

    constructor(private log: LoggingService, cs: CategoriesService) {
        log.debug({ type: 'CategoryListComponent:ctor' });
        this._categoryService = cs;
    }

    ngOnDestroy(): void {}

    ngOnInit() {
        this.log.debug({ type: 'CategoryListComponent:ngOnInit' });
        this.categories = this._categoryService
            .getCategories()
            .filter(x => x.CategoryName);
    }
}
